import rpcHeaders from '#/store/headers';
import { billingClient } from '#/clients';
import {
  CloudPricingRequest,
  ClientSecretRequest,
  AddPaymentMethodRequest,
  SavedPaymentRequest,
  DeletePaymentRequest,
  SetDefaultPaymentMethodRequest,
  SubscriptionCreationRequest,
  SubscriptionCancelRequest,
  SubscriptionListRequest,
  InvoiceListRequest,
  SubscriptionUncancelRequest,
  SubscriptionModificationRequest,
  SubscriptionPreviewChangeRequest,
} from '#/protobuf/service_billing_pb';

export function emptyState() {
  return {};
}

export const getters = {};

export const mutations = {};

export const actions = {
  retrieveCloudPricing: async ({ rootState }) => {
    console.info('retrieving cloud pricing');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new CloudPricingRequest();
      return new Promise((resolve, reject) => {
        billingClient.retrieveCloudPricing(request, headers, (err, response) => {
          if (err != null) {
            console.log('err getting pricing data', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('retrieved cloud pricing', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error in retrieval of pricing data', error);
      return Promise.reject(error);
    }
  },
  retrieveClientSecret: async ({ rootState }) => {
    console.info('retrieving client secret');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new ClientSecretRequest();
      return new Promise((resolve, reject) => {
        billingClient.retrieveClientSecret(request, headers, (err, response) => {
          if (err != null) {
            console.log('err retrieving client secret', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('retrieved client secret');
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error retrieving client secret', error);
      return Promise.reject(error);
    }
  },
  addPaymentMethod: async ({ rootState }) => {
    console.info('adding payment method');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new AddPaymentMethodRequest();
      return new Promise((resolve, reject) => {
        billingClient.addPaymentMethod(request, headers, (err, response) => {
          if (err != null) {
            console.log('err adding payment method', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('added payment method', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error adding payment method', error);
      return Promise.reject(error);
    }
  },
  retrieveSavedPaymentMethods: async ({ rootState }) => {
    console.info('retrieving saved payment methods');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SavedPaymentRequest();
      return new Promise((resolve, reject) => {
        billingClient.retrieveSavedPaymentMethods(request, headers, (err, response) => {
          if (err != null) {
            console.log('err retrieving saved payment methods', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('retrieved saved payment methods', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error retrieving saved payment methods', error);
      return Promise.reject(error);
    }
  },
  deletePayment: async ({ rootState }, { paymentId }) => {
    console.info('deleting saved payment', paymentId);
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new DeletePaymentRequest();
      request.setPaymentId(paymentId);
      return new Promise((resolve, reject) => {
        billingClient.deletePayment(request, headers, (err, response) => {
          if (err != null) {
            console.log('err deleting saved payment', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('deleted saved payment', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error deleting saved payment', error);
      return Promise.reject(error);
    }
  },
  setDefaultPaymentMethod: async ({ rootState }, { paymentId }) => {
    console.info('setting default payment method');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SetDefaultPaymentMethodRequest();
      request.setPaymentId(paymentId);
      return new Promise((resolve, reject) => {
        billingClient.setDefaultPaymentMethod(request, headers, (err, response) => {
          if (err != null) {
            console.log('err setting default payment method', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('set default payment method', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error setting default payment method', error);
      return Promise.reject(error);
    }
  },
  createSubscription: async ({ rootState }) => {
    console.info('creating subscription');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionCreationRequest();
      return new Promise((resolve, reject) => {
        billingClient.createSubscription(request, headers, (err, response) => {
          if (err != null) {
            console.log('err creating subscription', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('created subscription', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error creating subscription', error);
      return Promise.reject(error);
    }
  },
  cancelSubscription: async ({ rootState }) => {
    console.info('cancelling subscription');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionCancelRequest();
      return new Promise((resolve, reject) => {
        billingClient.cancelSubscription(request, headers, (err, response) => {
          if (err != null) {
            console.log('err cancelling subscription', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('cancelled subscription', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error cancelling subscription', error);
      return Promise.reject(error);
    }
  },
  listSubscriptions: async ({ rootState }) => {
    console.info('listing subscriptions');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionListRequest();
      return new Promise((resolve, reject) => {
        billingClient.listSubscriptions(request, headers, (err, response) => {
          if (err != null) {
            console.log('err listing subscriptions', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('listed subscriptions', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error listing subscriptions', error);
      return Promise.reject(error);
    }
  },
  listInvoices: async ({ rootState }) => {
    console.info('listing invoices');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new InvoiceListRequest();
      return new Promise((resolve, reject) => {
        billingClient.listInvoices(request, headers, (err, response) => {
          if (err != null) {
            console.log('err listing invoices', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('listed invoices', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error listing invoices', error);
      return Promise.reject(error);
    }
  },
  uncancelSubscription: async ({ rootState }) => {
    console.info('UNcancelling subscription');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionUncancelRequest();
      return new Promise((resolve, reject) => {
        billingClient.uncancelSubscription(request, headers, (err, response) => {
          if (err != null) {
            console.log('err UNcancelling subscription', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('UNcancelled subscription', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error UNcancelling subscription', error);
      return Promise.reject(error);
    }
  },
  modifySubscription: async ({ rootState }) => {
    console.info('modifying subscription');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionModificationRequest();
      return new Promise((resolve, reject) => {
        billingClient.modifySubscription(request, headers, (err, response) => {
          if (err != null) {
            console.log('err modifying subscription', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('modified subscription', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error modifying subscription', error);
      return Promise.reject(error);
    }
  },
  previewSubscriptionChange: async ({ rootState }) => {
    console.info('getting subscription change PREVIEW');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      const request = new SubscriptionPreviewChangeRequest();
      return new Promise((resolve, reject) => {
        billingClient.previewSubscriptionChange(request, headers, (err, response) => {
          if (err != null) {
            console.log('err getting subscription change PREVIEW', err);
            return reject(err);
          }
          const r = response.toObject();
          console.info('got subscription change PREVIEW', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.error('caught error getting subscription change PREVIEW', error);
      return Promise.reject(error);
    }
  },
};

export default {
  namespaced: true,
  state: emptyState(),
  getters,
  mutations,
  actions,
};
